import { EditableOptionsInputType } from '../types';

export const DEFAULT_INPUT_TYPE: EditableOptionsInputType = 'text';
export const DEFAULT_TEXT_AREA_MIN_ROWS = 2;
